import { useQuery } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { getUnregisterBill } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { IGetUnregisterBillRes } from "src/service/types/pay.type";

interface IUseGetUnregisterBillProps {
  enabled?: boolean;
  onSuccess?: (serviceList: IGetUnregisterBillRes[]) => void;
  onError?: () => void;
}

// billType(PAY/PROMOTION)별 "결제는 됐으나 사이트 미생성"된 청구 목록 조회 공용 훅
// PAY/PROMOTION 두 훅의 중복 제거를 위해 billType만 파라미터화
export function useGetUnregisterBill(
  billType: "PAY" | "PROMOTION",
  { enabled = true, onSuccess, onError }: IUseGetUnregisterBillProps = {}
) {
  const { handleError } = useApiError();
  const [userInfo] = useRecoilState(userInfoAtom);
  const product = getProductFromSessionStorage();
  // 내가 구매한 요금제 정보
  const { isLoading, isSuccess, data } = useQuery(
    ["getUnregisterBill", billType, product],
    async () => await getUnregisterBill({ billType, product }),
    {
      refetchOnMount: true, // 컴포넌트가 마운트될 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      refetchOnWindowFocus: true, // 윈도우가 포커스를 받을 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      keepPreviousData: true,
      enabled: enabled && product !== null && userInfo.userId !== "",
      onSuccess: onSuccess ? onSuccess : () => {},
      onError: onError ? onError : handleError,
    }
  );

  return { isLoading, isSuccess, data };
}
